module.exports = __webpack_public_path__ + "img/shuxian111.29f9e4a7.png";